// Curated avatar set — the player's persistent face on every leaderboard.
// Deliberately a small, fixed emoji palette (no uploads, no external images):
// an emoji is a couple of bytes on the denormalized participant entry and the
// published top-N, so identity costs ~nothing on the bandwidth-lean topology.
export const AVATARS = [
  '🦊', '🐼', '🦁', '🐸',
  '🐙', '🦄', '🐯', '🐨',
  '🦉', '🐺', '🐧', '🐹',
];

// Anything not from the set (legacy users, tampered writes) renders as none.
export const isAvatar = (a: unknown): a is string =>
  typeof a === 'string' && AVATARS.includes(a);
